module.exports = __webpack_public_path__ + "img/client24.990194cb.svg";